import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelSelect as _vModelSelect, vModelRadio as _vModelRadio } from "vue"

const _hoisted_1 = ["id", "for"]
const _hoisted_2 = ["id"]
const _hoisted_3 = ["id", "data-tooltip"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("svg", {
  class: "icon-svg",
  focusable: "false",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#help-circle-outline" })
], -1)
const _hoisted_5 = { class: "sr-only" }
const _hoisted_6 = ["id"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", {
  class: "sr-only",
  "data-children-count": "{{fejlbeskeder.length}}"
}, "Fejl:", -1)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 2,
  class: "form-hint"
}
const _hoisted_10 = { key: 3 }
const _hoisted_11 = {
  key: 0,
  style: {"margin-top":"1.6rem"}
}
const _hoisted_12 = ["id", "data-tooltip"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("svg", {
  class: "icon-svg",
  focusable: "false",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#help-circle-outline" })
], -1)
const _hoisted_14 = { class: "sr-only" }
const _hoisted_15 = {
  key: 4,
  class: "form-input-wrapper form-input-wrapper--suffix"
}
const _hoisted_16 = ["id", "maxlength", "disabled"]
const _hoisted_17 = {
  key: 0,
  class: "form-input-suffix",
  "aria-hidden": "true"
}
const _hoisted_18 = {
  key: 5,
  class: "form-input-wrapper form-input-wrapper--suffix"
}
const _hoisted_19 = {
  key: 0,
  class: "form-input-suffix",
  "aria-hidden": "true"
}
const _hoisted_20 = {
  key: 6,
  class: "form-input-wrapper form-input-wrapper--suffix"
}
const _hoisted_21 = {
  key: 0,
  class: "form-input-suffix",
  "aria-hidden": "true"
}
const _hoisted_22 = { key: 7 }
const _hoisted_23 = ["id", "disabled"]
const _hoisted_24 = ["value"]
const _hoisted_25 = { key: 8 }
const _hoisted_26 = ["disabled", "id"]
const _hoisted_27 = ["value"]
const _hoisted_28 = { key: 9 }
const _hoisted_29 = ["id"]
const _hoisted_30 = { for: "ja" }
const _hoisted_31 = { for: "nej" }
const _hoisted_32 = {
  key: 10,
  class: "form-group file-input"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("input", {
  type: "file",
  id: "input-file",
  name: "file"
}, null, -1)
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = {
  key: 11,
  class: "tco-input-group"
}
const _hoisted_36 = ["id", "maxlength", "disabled"]
const _hoisted_37 = ["id"]
const _hoisted_38 = ["data-default-value", "data-min-date", "data-max-date"]
const _hoisted_39 = ["id", "disabled"]
const _hoisted_40 = ["id"]
const _hoisted_41 = ["id"]
const _hoisted_42 = { class: "form-label" }
const _hoisted_43 = ["id"]
const _hoisted_44 = ["id", "data-tooltip"]
const _hoisted_45 = /*#__PURE__*/_createElementVNode("svg", {
  class: "icon-svg",
  focusable: "false",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#help-circle-outline" })
], -1)
const _hoisted_46 = { class: "sr-only" }
const _hoisted_47 = {
  key: 0,
  class: "form-hint"
}
const _hoisted_48 = { class: "form-group-radio mt-4" }
const _hoisted_49 = ["id", "name", "value", "data-js-target", "aria-controls", "aria-expanded"]
const _hoisted_50 = ["for", "id"]
const _hoisted_51 = ["id", "aria-hidden"]
const _hoisted_52 = { class: "py-4" }
const _hoisted_53 = ["for", "id"]
const _hoisted_54 = ["id"]
const _hoisted_55 = /*#__PURE__*/_createElementVNode("span", {
  class: "sr-only",
  "data-children-count": "{{fejlbeskeder.length}}"
}, "Fejl:", -1)
const _hoisted_56 = { key: 0 }
const _hoisted_57 = ["id"]
const _hoisted_58 = { class: "form-input-wrapper form-input-wrapper--suffix" }
const _hoisted_59 = {
  key: 0,
  class: "form-input-suffix",
  "aria-hidden": "true"
}
const _hoisted_60 = { class: "form-group-radio mt-3" }
const _hoisted_61 = ["id", "name", "value", "data-js-target", "aria-controls", "aria-expanded"]
const _hoisted_62 = ["for", "id"]
const _hoisted_63 = ["id", "aria-hidden"]
const _hoisted_64 = { class: "py-4" }
const _hoisted_65 = ["for", "id"]
const _hoisted_66 = ["id"]
const _hoisted_67 = /*#__PURE__*/_createElementVNode("span", {
  class: "sr-only",
  "data-children-count": "{{fejlbeskeder.length}}"
}, "Fejl:", -1)
const _hoisted_68 = { key: 0 }
const _hoisted_69 = ["id"]
const _hoisted_70 = { class: "form-input-wrapper form-input-wrapper--suffix" }
const _hoisted_71 = {
  key: 0,
  class: "form-input-suffix",
  "aria-hidden": "true"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_numeric = _resolveComponent("numeric")!
  const _component_numericInt = _resolveComponent("numericInt")!
  const _component_KlarTekst = _resolveComponent("KlarTekst")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.felt.felttype !== _ctx.FeltType.RADIO_JA_NEJ_MED_INPUT)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass({ 'form-group': true, 'form-error': !_ctx.felt.erValid })
        }, [
          (_ctx.felt.felttype !== _ctx.FeltType.OVERSKRIFT)
            ? (_openBlock(), _createElementBlock("label", {
                key: 0,
                id: 'tco_label_' + _ctx.genererDomId(_ctx.felt.tcoElementName),
                class: "form-label",
                for: _ctx.genererDomId(_ctx.felt.tcoElementName)
              }, [
                _createTextVNode(_toDisplayString(_ctx.maerkat) + " ", 1),
                (this.felt.erObligatorisk)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      id: 'tco_mandatory_' + _ctx.genererDomId(_ctx.felt.tcoElementName),
                      class: "tco_mandatory"
                    }, "*", 8, _hoisted_2))
                  : _createCommentVNode("", true),
                (_ctx.felt.hjaelpeTekst !== null && _ctx.felt.hjaelpeTekst !== '')
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      id: 'tco_tooltip_' + _ctx.genererDomId(_ctx.felt.tcoElementName),
                      class: "js-tooltip button-unstyled",
                      "data-tooltip-trigger": "click",
                      "data-tooltip": _ctx.felt.hjaelpeTekst !== null && _ctx.felt.hjaelpeTekst !== ''
              ? _ctx.felt.hjaelpeTekst
              : _ctx.felt.beskrivelse !== null && _ctx.felt.beskrivelse !== ''
              ? _ctx.felt.beskrivelse
              : _ctx.felt.maerkat
                    }, [
                      _hoisted_4,
                      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.felt.hjaelpeTekst), 1)
                    ], 8, _hoisted_3))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_1))
            : _createCommentVNode("", true),
          (!_ctx.felt.erValid)
            ? (_openBlock(), _createElementBlock("span", {
                key: 1,
                id: 'error_' + _ctx.genererDomId(_ctx.felt.tcoElementName),
                class: "form-error-message"
              }, [
                _hoisted_7,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fejlbeskeder, (item, index) => {
                  return (_openBlock(), _createElementBlock("span", { key: item }, [
                    _createTextVNode(_toDisplayString(item), 1),
                    (index < _ctx.fejlbeskeder.length - 1)
                      ? (_openBlock(), _createElementBlock("br", _hoisted_8))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ], 8, _hoisted_6))
            : _createCommentVNode("", true),
          (_ctx.felt.beskrivelse !== '')
            ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.felt.beskrivelse), 1))
            : _createCommentVNode("", true),
          (_ctx.felt.felttype === _ctx.FeltType.OVERSKRIFT)
            ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                ((_ctx.felt.vaerdi !== null && _ctx.felt.vaerdi !== '') || (_ctx.felt.hjaelpeTekst !== null && _ctx.felt.hjaelpeTekst !== ''))
                  ? (_openBlock(), _createElementBlock("h3", _hoisted_11, [
                      _createTextVNode(_toDisplayString(_ctx.felt.vaerdi) + " ", 1),
                      (_ctx.felt.hjaelpeTekst !== null && _ctx.felt.hjaelpeTekst !== '')
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            id: 'tco_tooltip_' + _ctx.genererDomId(_ctx.felt.tcoElementName),
                            class: "js-tooltip button-unstyled",
                            "data-tooltip-trigger": "click",
                            "data-tooltip": _ctx.felt.hjaelpeTekst !== null && _ctx.felt.hjaelpeTekst !== ''
              ? _ctx.felt.hjaelpeTekst
              : _ctx.felt.beskrivelse !== null && _ctx.felt.beskrivelse !== ''
              ? _ctx.felt.beskrivelse
              : _ctx.felt.maerkat
                          }, [
                            _hoisted_13,
                            _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.felt.hjaelpeTekst), 1)
                          ], 8, _hoisted_12))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.felt.felttype === _ctx.FeltType.TEKSTFELT_TEKST)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _withDirectives(_createElementVNode("input", {
                  id: _ctx.genererDomId(_ctx.felt.tcoElementName),
                  onfocus: "this.select()",
                  class: _normalizeClass(_ctx.felt.specifikCssClass != null && _ctx.felt.specifikCssClass != '' ? _ctx.felt.specifikCssClass :  'form-input input-width-xl'),
                  type: "text",
                  maxlength: _ctx.felt.maksVaerdi > 0 ? _ctx.felt.maksVaerdi : '',
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.felt.vaerdi) = $event)),
                  disabled: _ctx.readOnly,
                  "aria-describedby": "'error_' + genererDomId(felt.tcoElementName)",
                  onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onBlur(_ctx.felt)))
                }, null, 42, _hoisted_16), [
                  [_vModelText, _ctx.felt.vaerdi]
                ]),
                (_ctx.felt.enhed !== null && _ctx.felt.enhed !== '')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.felt.enhed), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.felt.felttype === _ctx.FeltType.TEKSTFELT_TAL)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createVNode(_component_numeric, {
                  id: _ctx.genererDomId(_ctx.felt.tcoElementName),
                  class: _normalizeClass(_ctx.felt.specifikCssClass != null && _ctx.felt.specifikCssClass != '' ? _ctx.felt.specifikCssClass :  'form-input input-width-xl'),
                  min: _ctx.felt.minVaerdi !== null ? _ctx.felt.minVaerdi : '',
                  max: _ctx.felt.maksVaerdi !== null ? _ctx.felt.maksVaerdi : '',
                  valueFromBackend: _ctx.felt.vaerdi,
                  "onUpdate:valueFromBackend": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.felt.vaerdi) = $event)),
                  disabled: _ctx.readOnly,
                  "aria-describedby": "'error_' + genererDomId(felt.tcoElementName)",
                  onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onBlur(_ctx.felt, false))),
                  onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onChange(_ctx.felt))),
                  onKeyup: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onKeyUp(_ctx.felt)))
                }, null, 8, ["id", "class", "min", "max", "valueFromBackend", "disabled"]),
                (_ctx.felt.enhed !== null && _ctx.felt.enhed !== '')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_ctx.felt.enhed), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.felt.felttype === _ctx.FeltType.TEKSTFELT_HELTAL)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                _createVNode(_component_numericInt, {
                  id: _ctx.genererDomId(_ctx.felt.tcoElementName),
                  class: _normalizeClass(_ctx.felt.specifikCssClass != null && _ctx.felt.specifikCssClass != '' ? _ctx.felt.specifikCssClass :  'form-input input-width-xl'),
                  min: _ctx.felt.minVaerdi !== null ? _ctx.felt.minVaerdi : '',
                  max: _ctx.felt.maksVaerdi !== null ? _ctx.felt.maksVaerdi : '',
                  valueFromBackend: _ctx.felt.vaerdi,
                  "onUpdate:valueFromBackend": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.felt.vaerdi) = $event)),
                  disabled: _ctx.readOnly,
                  "aria-describedby": "'error_' + genererDomId(felt.tcoElementName)",
                  onBlur: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onBlur(_ctx.felt, false))),
                  onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onChange(_ctx.felt))),
                  onKeyup: _cache[9] || (_cache[9] = ($event: any) => (_ctx.onKeyUp(_ctx.felt)))
                }, null, 8, ["id", "class", "min", "max", "valueFromBackend", "disabled"]),
                (_ctx.felt.enhed !== null && _ctx.felt.enhed !== '')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_ctx.felt.enhed), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.felt.felttype === _ctx.FeltType.VALGLISTE)
            ? (_openBlock(), _createElementBlock("span", _hoisted_22, [
                _withDirectives(_createElementVNode("select", {
                  id: _ctx.genererDomId(_ctx.felt.tcoElementName),
                  class: _normalizeClass(['form-select']),
                  name: "options",
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.felt.vaerdi) = $event)),
                  disabled: _ctx.readOnly,
                  onBlur: _cache[11] || (_cache[11] = ($event: any) => (_ctx.onBlur(_ctx.felt))),
                  onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.onChange(_ctx.felt)))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.felt.valgmuligheder, (key, value) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: value,
                      key: key
                    }, _toDisplayString(key), 9, _hoisted_24))
                  }), 128))
                ], 40, _hoisted_23), [
                  [_vModelSelect, _ctx.felt.vaerdi]
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.felt.felttype === _ctx.FeltType.PRODUKTGRUPPEVÆLGER)
            ? (_openBlock(), _createElementBlock("span", _hoisted_25, [
                _withDirectives(_createElementVNode("select", {
                  disabled: _ctx.readOnly,
                  onChange: _cache[13] || (_cache[13] = ($event: any) => (this.initValgteProduktGruppe(_ctx.felt.vaerdi))),
                  id: _ctx.genererDomId(_ctx.felt.tcoElementName),
                  class: _normalizeClass(['form-select']),
                  name: "options",
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.felt.vaerdi) = $event)),
                  onBlur: _cache[15] || (_cache[15] = ($event: any) => (_ctx.onBlur(_ctx.felt)))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.produktGrupper, (p) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: p.id,
                      key: p.id
                    }, _toDisplayString(_ctx.formatProduktGruppe(p)), 9, _hoisted_27))
                  }), 128))
                ], 40, _hoisted_26), [
                  [_vModelSelect, _ctx.felt.vaerdi]
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.felt.felttype === _ctx.FeltType.RADIO_JA_NEJ)
            ? (_openBlock(), _createElementBlock("span", _hoisted_28, [
                _createElementVNode("ul", {
                  class: "nobullet-list",
                  id: _ctx.genererDomId(_ctx.felt.tcoElementName)
                }, [
                  _createElementVNode("li", null, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-radio radio-large",
                      type: "radio",
                      id: "ja",
                      value: "true",
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.felt.vaerdi) = $event)),
                      onChange: _cache[17] || (_cache[17] = ($event: any) => (_ctx.onChange(_ctx.felt)))
                    }, null, 544), [
                      [_vModelRadio, _ctx.felt.vaerdi]
                    ]),
                    _createElementVNode("label", _hoisted_30, [
                      _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.og-blanket.formularfelt.radio.ja' }, null, 8, ["tekstNoegle"])
                    ])
                  ]),
                  _createElementVNode("li", null, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-radio radio-large",
                      type: "radio",
                      id: "nej",
                      value: "false",
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.felt.vaerdi) = $event)),
                      onChange: _cache[19] || (_cache[19] = ($event: any) => (_ctx.onChange(_ctx.felt)))
                    }, null, 544), [
                      [_vModelRadio, _ctx.felt.vaerdi]
                    ]),
                    _createElementVNode("label", _hoisted_31, [
                      _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.og-blanket.formularfelt.radio.nej' }, null, 8, ["tekstNoegle"])
                    ])
                  ])
                ], 8, _hoisted_29)
              ]))
            : _createCommentVNode("", true),
          (_ctx.felt.felttype === _ctx.FeltType.FIL_UPLOAD)
            ? (_openBlock(), _createElementBlock("span", _hoisted_32, _hoisted_34))
            : _createCommentVNode("", true),
          (_ctx.felt.felttype === _ctx.FeltType.TEKSTFELT_AREA)
            ? (_openBlock(), _createElementBlock("span", _hoisted_35, [
                _withDirectives(_createElementVNode("textarea", {
                  class: "form-input input-width-xl",
                  rows: "5",
                  placeholder: "",
                  id: _ctx.genererDomId(_ctx.felt.tcoElementName),
                  onfocus: "this.select()",
                  type: "text",
                  maxlength: _ctx.felt.maksVaerdi > 0 ? _ctx.felt.maksVaerdi : '',
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.felt.vaerdi) = $event)),
                  disabled: _ctx.readOnly,
                  "aria-describedby": "'error_' + genererDomId(felt.tcoElementName)",
                  onBlur: _cache[21] || (_cache[21] = ($event: any) => (_ctx.onBlur(_ctx.felt)))
                }, null, 40, _hoisted_36), [
                  [_vModelText, _ctx.felt.vaerdi]
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.felt.felttype === _ctx.FeltType.DATO)
            ? (_openBlock(), _createElementBlock("span", {
                key: 12,
                id: 'tco_date_picker_'+_ctx.genererDomId(_ctx.felt.tcoElementName)
              }, [
                _createElementVNode("div", {
                  class: "date-picker",
                  "data-default-value": _ctx.felt.vaerdi,
                  "data-min-date": _ctx.felt.minDato,
                  "data-max-date": _ctx.felt.maksDato
                }, [
                  _withDirectives(_createElementVNode("input", {
                    id: _ctx.genererDomId(_ctx.felt.tcoElementName),
                    class: _normalizeClass(_ctx.felt.specifikCssClass != null && _ctx.felt.specifikCssClass !== '' ? _ctx.felt.specifikCssClass :  'form-input input-width-xl'),
                    type: "text",
                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.felt.vaerdi) = $event)),
                    disabled: _ctx.readOnly,
                    "aria-describedby": "'error_' + genererDomId(felt.tcoElementName)",
                    onChange: _cache[23] || (_cache[23] = ($event: any) => (_ctx.onDatoFeltChange(_ctx.felt)))
                  }, null, 42, _hoisted_39), [
                    [
                      _vModelText,
                      _ctx.felt.vaerdi,
                      void 0,
                      { lazy: true }
                    ]
                  ])
                ], 8, _hoisted_38)
              ], 8, _hoisted_37))
            : _createCommentVNode("", true),
          (_ctx.felt.felttype === _ctx.FeltType.STATIC_TEKST)
            ? (_openBlock(), _createElementBlock("p", {
                key: 13,
                class: "mt-0",
                id: _ctx.genererDomId(_ctx.felt.tcoElementName)
              }, _toDisplayString(_ctx.formatStaticTekst(_ctx.felt)), 9, _hoisted_40))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.felt.felttype === _ctx.FeltType.RADIO_JA_NEJ_MED_INPUT)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "js-radio-toggle-group form-group",
          id: 'radio-collapse-'+_ctx.genererDomId(_ctx.felt.tcoElementName)
        }, [
          _createElementVNode("fieldset", null, [
            _createElementVNode("legend", _hoisted_42, [
              _createTextVNode(_toDisplayString(_ctx.maerkat) + " ", 1),
              (this.felt.erObligatorisk)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    id: 'tco_mandatory_' + _ctx.genererDomId(_ctx.felt.tcoElementName),
                    class: "tco_mandatory"
                  }, "*", 8, _hoisted_43))
                : _createCommentVNode("", true),
              (_ctx.felt.hjaelpeTekst)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    id: 'tco_tooltip_' + _ctx.genererDomId(_ctx.felt.tcoElementName),
                    class: "js-tooltip button-unstyled",
                    "data-tooltip-trigger": "click",
                    "data-tooltip": _ctx.felt.hjaelpeTekst
                  }, [
                    _hoisted_45,
                    _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.felt.hjaelpeTekst), 1)
                  ], 8, _hoisted_44))
                : _createCommentVNode("", true)
            ]),
            (_ctx.felt.beskrivelse)
              ? (_openBlock(), _createElementBlock("span", _hoisted_47, _toDisplayString(_ctx.felt.beskrivelse), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_48, [
              _withDirectives(_createElementVNode("input", {
                id: 'radio-ja-'+_ctx.genererDomId(_ctx.felt.tcoElementName),
                type: "radio",
                name: _ctx.genererDomId(_ctx.felt.tcoElementName),
                value: _ctx.felt.jaRadioVaerdi,
                class: "form-radio radio-large",
                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.felt.vaerdi) = $event)),
                onChange: _cache[25] || (_cache[25] = ($event: any) => (_ctx.onRadioJaNejChange(_ctx.felt))),
                "data-js-target": '#collapse-radio-ja-'+_ctx.genererDomId(_ctx.felt.tcoElementName),
                "aria-controls": 'collapse-radio-ja-'+_ctx.genererDomId(_ctx.felt.tcoElementName),
                "aria-expanded": _ctx.felt.vaerdi === _ctx.felt.jaRadioVaerdi
              }, null, 40, _hoisted_49), [
                [_vModelRadio, _ctx.felt.vaerdi]
              ]),
              _createElementVNode("label", {
                for: 'radio-ja-'+_ctx.genererDomId(_ctx.felt.tcoElementName),
                id: 'tco_label_radio-ja-'+_ctx.genererDomId(_ctx.felt.tcoElementName)
              }, _toDisplayString(_ctx.felt.jaRadioMaerkat), 9, _hoisted_50)
            ]),
            _createElementVNode("div", {
              id: 'collapse-radio-ja-'+_ctx.genererDomId(_ctx.felt.tcoElementName),
              "aria-hidden": _ctx.felt.vaerdi !== _ctx.felt.jaRadioVaerdi,
              class: _normalizeClass({ 'box-border-l': true, 'collapsed': _ctx.felt.vaerdi !== _ctx.felt.jaRadioVaerdi })
            }, [
              _createElementVNode("div", _hoisted_52, [
                _createElementVNode("div", {
                  class: _normalizeClass({ 'form-group': true, 'form-error': !_ctx.felt.erValid })
                }, [
                  _createElementVNode("label", {
                    class: "form-label",
                    for: 'ja-input-' + _ctx.genererDomId(_ctx.felt.jaInputTcoElementName),
                    id: 'tco_label_ja-input-'+_ctx.genererDomId(_ctx.felt.jaInputTcoElementName)
                  }, _toDisplayString(_ctx.felt.jaInputMaerkat), 9, _hoisted_53),
                  (!_ctx.felt.erValid)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        id: 'error_ja-input-' + _ctx.genererDomId(_ctx.felt.jaInputTcoElementName),
                        class: "form-error-message"
                      }, [
                        _hoisted_55,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fejlbeskeder, (item, index) => {
                          return (_openBlock(), _createElementBlock("span", { key: item }, [
                            _createTextVNode(_toDisplayString(item), 1),
                            (index < _ctx.fejlbeskeder.length - 1)
                              ? (_openBlock(), _createElementBlock("br", _hoisted_56))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ], 8, _hoisted_54))
                    : _createCommentVNode("", true),
                  (_ctx.felt.jaInputBeskrivelse)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 1,
                        class: "form-hint",
                        id: 'hint-ja-input-'+_ctx.genererDomId(_ctx.felt.jaInputTcoElementName)
                      }, _toDisplayString(_ctx.felt.jaInputBeskrivelse), 9, _hoisted_57))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_58, [
                    _createVNode(_component_numeric, {
                      id: 'ja-input-' + _ctx.genererDomId(_ctx.felt.jaInputTcoElementName),
                      class: "form-input input-width-xl",
                      min: _ctx.felt.minVaerdi !== null ? _ctx.felt.minVaerdi : '',
                      max: _ctx.felt.maksVaerdi !== null ? _ctx.felt.maksVaerdi : '',
                      valueFromBackend: _ctx.felt.jaInputVaerdi,
                      "onUpdate:valueFromBackend": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.felt.jaInputVaerdi) = $event)),
                      disabled: _ctx.felt.jaInputReadOnly,
                      "aria-describedby": 'error_' + _ctx.genererDomId(_ctx.felt.tcoElementName),
                      onBlur: _cache[27] || (_cache[27] = ($event: any) => (_ctx.onBlurRadioJaNejInput(_ctx.felt, true))),
                      onChange: _cache[28] || (_cache[28] = ($event: any) => (_ctx.onChange(_ctx.felt)))
                    }, null, 8, ["id", "min", "max", "valueFromBackend", "disabled", "aria-describedby"]),
                    (_ctx.felt.jaInputEnhed !== null && _ctx.felt.jaInputEnhed !== '')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_59, _toDisplayString(_ctx.felt.jaInputEnhed), 1))
                      : _createCommentVNode("", true)
                  ])
                ], 2)
              ])
            ], 10, _hoisted_51),
            _createElementVNode("div", _hoisted_60, [
              _withDirectives(_createElementVNode("input", {
                id: 'radio-nej-'+_ctx.genererDomId(_ctx.felt.tcoElementName),
                type: "radio",
                name: _ctx.genererDomId(_ctx.felt.tcoElementName),
                value: _ctx.felt.nejRadioVaerdi,
                class: "form-radio radio-large",
                "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.felt.vaerdi) = $event)),
                onChange: _cache[30] || (_cache[30] = ($event: any) => (_ctx.onRadioJaNejChange(_ctx.felt))),
                "data-js-target": '#collapse-radio-nej-'+_ctx.genererDomId(_ctx.felt.tcoElementName),
                "aria-controls": 'collapse-radio-nej-'+_ctx.genererDomId(_ctx.felt.tcoElementName),
                "aria-expanded": _ctx.felt.vaerdi === _ctx.felt.nejRadioVaerdi
              }, null, 40, _hoisted_61), [
                [_vModelRadio, _ctx.felt.vaerdi]
              ]),
              _createElementVNode("label", {
                for: 'radio-nej-'+_ctx.genererDomId(_ctx.felt.tcoElementName),
                id: 'tco_label_radio-nej-'+_ctx.genererDomId(_ctx.felt.tcoElementName)
              }, _toDisplayString(_ctx.felt.nejRadioMaerkat), 9, _hoisted_62)
            ]),
            _createElementVNode("div", {
              id: 'collapse-radio-nej-'+_ctx.genererDomId(_ctx.felt.tcoElementName),
              "aria-hidden": _ctx.felt.vaerdi !== _ctx.felt.nejRadioVaerdi,
              class: _normalizeClass({ 'box-border-l': true, 'collapsed': _ctx.felt.vaerdi !== _ctx.felt.nejRadioVaerdi })
            }, [
              _createElementVNode("div", _hoisted_64, [
                _createElementVNode("div", {
                  class: _normalizeClass({ 'form-group': true, 'form-error': !_ctx.felt.erValid })
                }, [
                  _createElementVNode("label", {
                    class: "form-label",
                    for: 'nej-input-' + _ctx.genererDomId(_ctx.felt.nejInputTcoElementName),
                    id: 'tco_label_nej-input-'+_ctx.genererDomId(_ctx.felt.nejInputTcoElementName)
                  }, _toDisplayString(_ctx.felt.nejInputMaerkat), 9, _hoisted_65),
                  (!_ctx.felt.erValid)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        id: 'error_nej-input-' + _ctx.genererDomId(_ctx.felt.nejInputTcoElementName),
                        class: "form-error-message"
                      }, [
                        _hoisted_67,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fejlbeskeder, (item, index) => {
                          return (_openBlock(), _createElementBlock("span", { key: item }, [
                            _createTextVNode(_toDisplayString(item), 1),
                            (index < _ctx.fejlbeskeder.length - 1)
                              ? (_openBlock(), _createElementBlock("br", _hoisted_68))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ], 8, _hoisted_66))
                    : _createCommentVNode("", true),
                  (_ctx.felt.nejInputBeskrivelse)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 1,
                        class: "form-hint",
                        id: 'hint-nej-input-'+_ctx.genererDomId(_ctx.felt.nejInputTcoElementName)
                      }, _toDisplayString(_ctx.felt.nejInputBeskrivelse), 9, _hoisted_69))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_70, [
                    _createVNode(_component_numeric, {
                      id: 'nej-input-' + _ctx.genererDomId(_ctx.felt.nejInputTcoElementName),
                      class: "form-input input-width-xl",
                      min: _ctx.felt.minVaerdi !== null ? _ctx.felt.minVaerdi : '',
                      max: _ctx.felt.maksVaerdi !== null ? _ctx.felt.maksVaerdi : '',
                      valueFromBackend: _ctx.felt.nejInputVaerdi,
                      "onUpdate:valueFromBackend": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.felt.nejInputVaerdi) = $event)),
                      disabled: _ctx.felt.nejInputReadOnly,
                      "aria-describedby": 'error_' + _ctx.genererDomId(_ctx.felt.tcoElementName),
                      onBlur: _cache[32] || (_cache[32] = ($event: any) => (_ctx.onBlurRadioJaNejInput(_ctx.felt, false))),
                      onChange: _cache[33] || (_cache[33] = ($event: any) => (_ctx.onChange(_ctx.felt)))
                    }, null, 8, ["id", "min", "max", "valueFromBackend", "disabled", "aria-describedby"]),
                    (_ctx.felt.nejInputEnhed !== null && _ctx.felt.nejInputEnhed !== '')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_71, _toDisplayString(_ctx.felt.nejInputEnhed), 1))
                      : _createCommentVNode("", true)
                  ])
                ], 2)
              ])
            ], 10, _hoisted_63)
          ])
        ], 8, _hoisted_41))
      : _createCommentVNode("", true)
  ], 64))
}